import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../../shared/app-settings/app-settings.service';
import { Link } from './link.interface';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  public allowLinks;

  public linksMap: Link[] = [{
    link: '/app/#/game',
    title: this.translate.instant('Поиграть!'),
    name: 'play',
    external: true
  }, {
    link: '/pages/',
    title: this.translate.instant('Страницы'),
    name: 'pages',
    external: true
  }, {
    link: '/leads/',
    title: this.translate.instant('Лиды'),
    name: 'leads',
    external: true
  }, {
    link: '/app/#/profile/profile',
    title: this.translate.instant('Учетная запись'),
    name: 'account',
    external: true
  }, {
    link: '/app/#/domain/mydomains',
    title: this.translate.instant('Домены'),
    name: 'domains',
    external: true
  }, {
    link: '/channels',
    title: this.translate.instant('UTM'),
    name: 'utm',
    external: false
  }, {
    link: '/company/profile/',
    title: this.translate.instant('Компания'),
    name: 'wl',
    external: true
  }, {
    link: '/partners',
    title: this.translate.instant('Партнеры'),
    name: 'partners',
    external: false
  }, {
    link: '/services',
    title: this.translate.instant('Услуги'),
    name: 'services',
    external: false
  }, {
    link: '/app/#/billing/activeServices',
    title: this.translate.instant('Оплата'),
    name: 'billing',
    external: true
  }];

  constructor(
    private appSettings: AppSettingsService,
    private translate: TranslateService
  ) {
    this.allowLinks = this.appSettings.data.menu;
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/menu/menu.component.ts